import React, { useEffect, useMemo, useState } from "react";
import "./Work.css";
import { Link } from "react-router-dom";

import SH from "../../assets/SvenskHusmandator.png";
import P from "../../assets/Period_VK.png";
import PO from "../../assets/ThisPortfoilio.png";
import PJ from "../../assets/projectra1.png";
import LO from "../../assets/projectralogga.png";

const projects = [
  {
    title: "PROJECTRA",
    sub: "Design Project, Development",
    category: ["design", "development"],
    image: PJ,
    slug: "projectra",
  },
  {
    title: "PROJECTRA Logo (Wordmark and Brand Mark)",
    sub: "Design",
    category: ["design", "other"],
    image: LO,
    slug: "projectra-logo",
  },
  {
    title: "Svensk Husman Game",
    sub: "Game / Development",
    category: ["development"],
    image: SH,
    slug: "svensk-husman-game",
  },
  {
    title: "This Portfolio",
    sub: "React Development",
    category: ["development", "design"],
    image: PO,
    slug: "this-portfolio",
  },
  {
    title: "Period.",
    sub: "Social Initiative",
    category: ["other"],
    image: P,
    slug: "period",
  },
];

function Work() {
  const [filter, setFilter] = useState("all");
  const [isMobile, setIsMobile] = useState(false);

  /* Detect mobile */
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 600px)");

    const updateIsMobile = () => setIsMobile(mediaQuery.matches);
    updateIsMobile();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", updateIsMobile);
    } else {
      mediaQuery.addListener(updateIsMobile); // Safari fallback
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", updateIsMobile);
      } else {
        mediaQuery.removeListener(updateIsMobile);
      }
    };
  }, []);

  /* Filter projects */
  const filteredProjects = useMemo(() => {
    if (filter === "all") return projects;
    return projects.filter((p) => p.category.includes(filter));
  }, [filter]);

  /* Duplicate only for desktop carousel loop */
  const loopedList = useMemo(() => {
    if (filter === "all" && !isMobile) {
      return [...filteredProjects, ...filteredProjects];
    }
    return filteredProjects;
  }, [filter, isMobile, filteredProjects]);

  return (
    <section id="work" className="work-section">
      <div className="work-header">
        <h1 className="title">Recent Work</h1>

        <div className="filter-buttons">
          <button
            className={filter === "all" ? "active" : ""}
            onClick={() => setFilter("all")}
          >
            All
          </button>

          <button
            className={filter === "design" ? "active" : ""}
            onClick={() => setFilter("design")}
          >
            Design
          </button>

          <button
            className={filter === "development" ? "active" : ""}
            onClick={() => setFilter("development")}
          >
            Development
          </button>

          <button
            className={filter === "other" ? "active" : ""}
            onClick={() => setFilter("other")}
          >
            Other
          </button>
        </div>
      </div>

      <div className="carousel">
        <div
          className={`carousel-track ${
            filter === "all" && !isMobile ? "animate" : ""
          }`}
        >
          {loopedList.map((p, i) => (
            <Link
              key={`${p.slug}-${i}`}
              to={`/project/${p.slug}`}
              className="carousel-card"
            >
              <img src={p.image} alt={p.title} />

              <div className="carousel-info">
                <h3>{p.title}</h3>
                <p>{p.sub}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Work;








